import React from "react";

const Header = () => {
  return (
    <div className="header-text">
      <h1>Weather App</h1>
    </div>
  );
};

export default Header;
